import { assetUrl } from '@Shared/Helpers/Utilities';

export const AUTOMATE = [
    {
        icon: 'users',
        title: __('Send Referrals Out'),
        text: __(
            'When you get a new referral, send it directly to your CRM, database, or website.'
        ),
    },
    {
        icon: 'star-checked',
        title: __('Qualify Referrals'),
        text: __(
            'Qualify the referrals if it converts by updating a status in your CRM. Or by connecting Stripe.'
        ),
    },
    {
        icon: 'link',
        title: __('Generate Links'),
        text: __(
            'Generate a referral links for your new customer that converted. Repeat the process and grow!'
        ),
    },
];

export const INTEGRATION_LOGOS = [
    'api',
    'webhook',
    'hubspot',
    'salesforce',
    'intercom',
    'zapier',
    'zoho',
    'pipedrive',
    'servicetitan',
    'monday',
    'stripe',
];

export const API_TEXTS = [
    __('Add users to your campaign in real time, generating their referral links'),
    __('Send new referred users to any endpoint using Webhooks'),
    __('Qualify ‘referred users’ once they successfully convert'),
    __('View, update or delete user records'),
    __('See all rewards due, and issue new rewards'),
];

export const INTEGRATIONS_BLOG = {
    type: 'dark',
    className: 'mr-auto mt-8 flex-[2] !gap-6',
    position: 'start',
    icon: 'hat',
    title: __('Ready to get referrals on autopilot?'),
    desc: (
        <>
            {__(
                'Make sure the referral program software you choose offers deep integrations with most CRMs and payment gateways. This helps you automate all the manual admin usually associated with running a referral program.'
            )}
            <br />
            {__(
                'Referral Factory integrates directly with HubSpot, Stripe, Zoho, Intercom, Salesforce, Pipedrive, Service Titan, Zapier. We also have a flexible API and webhook capabilities.'
            )}
        </>
    ),
    imgClassName: 'flex-1 max-w-[460px]',
    image: assetUrl('/assets/images/webp/web/integrations/wow-man.webp'),
    alt: 'wow man',
    link: 'customer.auth.register',
    linkText: 'Start free trial',
};

export const INTEGRATION_STATS = [
    {
        title: '2x',
        text: __(
            'Referred leads are 2x more likely to convert than leads acquired from other channels like paid ads.'
        ),
        link: 'web.pages.marketing_statistics',
        linkText: __('See more referral marketing statistics'),
    },
    {
        title: '13.2%',
        text: __(
            'Referred customers spend 13.2% more on average. This means you’re getting higher value leads.'
        ),
        link: 'web.pages.marketing_statistics',
        linkText: __('See more referral marketing statistics'),
    },
    {
        title: '16%',
        text: __(
            'The amount you can increase your lead pipeline by. Get 16% more leads simply by asking for referrals!'
        ),
        link: 'web.pages.marketing_statistics',
        linkText: __('See more referral marketing statistics'),
    },
];

export const WEBHOOK_BLOG = {
    icon: 'rocket',
    title: __('Why do we have webhooks and an API?'),
    description: (
        <>
            {__(
                'All the data generated by your referral program belongs to you, and can be accessed via your dashboard or API. We offer many flexible ways to interact with the users participating in your referral program via our API. You can read, write, and edit your data with ease.'
            )}
            <br />
            {__(
                'We also offer webhooks so that you can easily send users out and into Referral Factory. Whether you want to send new referrals into your own systems, or qualify a referral that convert, it’s all possible! Please note that you will need an experienced developer to interact with our API. If you don’t have a developer we suggest you use one of our ‘no code’ integrations.'
            )}
            <br />
            {__(
                'Please note that you will need an experienced developer to interact with our API. If you don’t have a developer we suggest you use one of our ‘no code’ integrations.'
            )}
        </>
    ),
    buttonName: __('Read our api docs'),
    img: 'webhook',
};

export const HUBSPOT_BLOG = [
    {
        icon: 'link',
        title: __('Generate links for your HubSpot contacts'),
        description: __(
            'Use the sync feature to generate referral links for all or some of your contacts in HubSpot. The sync process will automatically enrol your contacts into your referral program, and update their records in HubSpot to show their unique links and tracking stats.'
        ),
        buttonName: __('Start trial'),
        img: 'hubspot-1',
    },
    {
        icon: 'users',
        title: __('Send new referrals straight into HubSpot'),
        description: __(
            'Configure your integration to send all new referrals straight into the HubSpot workflows you already use. You can then setup rules to auto-qualify the leads that convert, using various HubSpot properties like: lead status, lifecycle stage, deal stages, and custom properties.'
        ),
        buttonName: __('Start trial'),
        img: 'hubspot-2',
    },
];

export const HUBSPOT_LINKS = {
    embedVideoLink: 'https://www.youtube.com/embed/sISzyI7qRsg?si=zHQqg7NKexbqsKhC',
    videoLink: 'https://www.youtube.com/watch?v=sISzyI7qRsg',
    appLink:
        'https://ecosystem.hubspot.com/marketplace/apps/marketing/lead-generation/referral-factory',
};

export const INTERCOM_BLOG = [
    {
        icon: 'link',
        title: __('Generate links for your Intercom contacts'),
        description: __(
            'Use the sync feature to generate referral links for all or some of your contacts in Intercom. The sync process will automatically enrol your contacts into your referral program, and update their records in Intercom to show their unique links and tracking stats.'
        ),
        buttonName: __('Start trial'),
        img: 'intercom-1',
    },
    {
        icon: 'users',
        title: __('Send new referrals straight into Intercom'),
        description: __(
            'Configure your integration to send all new referrals straight into the Intercom workflows you already use. You can then setup rules to auto-qualify the leads that convert, using various Intercom properties like: lead status, lifecycle stage, deal stages, and custom properties.'
        ),
        buttonName: __('Start trial'),
        img: 'intercom-2',
    },
];

export const INTERCOM_LINKS = {
    embedVideoLink: 'https://www.youtube.com/embed/rSIlwkdHTyc?si=dlVAmK5KI_uiV1su',
    videoLink: 'https://www.youtube.com/watch?v=rSIlwkdHTyc',
    appLink: 'https://www.intercom.com/app-store/?app_package_code=referral-factory',
};

export const MONDAY_BLOG = [
    {
        icon: 'link',
        title: __('Generate links for your Monday.com contacts'),
        description: __(
            'Use the sync feature to generate referral links for all or some of your contacts in Monday.com. The sync process will automatically enrol your contacts into your referral program, and update their records in Monday to show their unique links and tracking stats.'
        ),
        buttonName: __('Start trial'),
        img: 'monday-1',
    },
    {
        icon: 'users',
        title: __('Send new referrals straight into Monday.com'),
        description: __(
            'Configure your integration to send all new referrals straight into the Monday.com workflows you already use. You can then setup rules to auto-qualify the leads that convert, using various Monday properties like: lead status, lifecycle stage, deal stages, and custom properties.'
        ),
        buttonName: __('Start trial'),
        img: 'monday-2',
    },
];

export const MONDAY_LINKS = {
    embedVideoLink: 'https://www.youtube.com/embed/gqFngUhESU0?si=OzeTHKh07ZqjlnSU',
    videoLink: 'https://www.youtube.com/watch?v=gqFngUhESU0',
    appLink: '',
};

export const PIPEDRIVE_BLOG = [
    {
        icon: 'link',
        title: __('Generate links for your Pipedrive contacts'),
        description: __(
            'Use the sync feature to generate referral links for all or some of your contacts in Pipedrive The sync process will automatically enrol your contacts into your referral program, and update their records in Pipedrive to show their unique links and tracking stats.'
        ),
        buttonName: __('Start trial'),
        img: 'pipedrive-1',
    },
    {
        icon: 'users',
        title: __('Send new referrals straight into Pipedrive'),
        description: __(
            'Configure your integration to send all new referrals straight into the Pipedrive workflows you already use. You can then setup rules to auto-qualify the leads that convert, using various Pipedrive properties like: lead status, lifecycle stage, deal stages, and custom properties.'
        ),
        buttonName: __('Start trial'),
        img: 'pipedrive-2',
    },
];

export const PIPEDRIVE_LINKS = {
    embedVideoLink: 'https://www.youtube.com/embed/L_Nghq5DAA0?si=0nODQff3DWI0CkEt',
    videoLink: 'https://www.youtube.com/watch?v=L_Nghq5DAA0',
    appLink: 'https://www.pipedrive.com/en/marketplace/app/referral-factory/a2ef4fd38df84b0d',
};

export const SALESFORCE_BLOG = [
    {
        icon: 'link',
        title: __('Generate links for your Salesforce contacts'),
        description: __(
            'Use the sync feature to generate referral links for all or some of your contacts in Salesforce The sync process will automatically enrol your contacts into your referral program, and update their records in Salesforce to show their unique links and tracking stats.'
        ),
        buttonName: __('Start trial'),
        img: 'salesforce-1',
    },
    {
        icon: 'users',
        title: __('Send new referrals straight into Salesforce'),
        description: __(
            'Configure your integration to send all new referrals straight into the Salesforce workflows you already use. You can then setup rules to auto-qualify the leads that convert, using various Salesforce properties like: lead status, lifecycle stage, deal stages, and custom properties.'
        ),
        buttonName: __('Start trial'),
        img: 'salesforce-2',
    },
];

export const SALESFORCE_LINKS = {
    embedVideoLink: 'https://www.youtube.com/embed/6Fv0fuqAG8o?si=TRlSHtKzPnrpyk6d',
    videoLink: 'https://www.youtube.com/watch?v=6Fv0fuqAG8o',
    appLink: '',
};

export const SERVICE_TITAN_BLOG = [
    {
        icon: 'link',
        title: __('Generate links for your ServiceTitan contacts '),
        description: __(
            'Use the sync feature to generate referral links for all or some of your contacts in ServiceTitan The sync process will automatically enrol your contacts into your referral program, and update their records in ServiceTitan to show their unique links and tracking stats.'
        ),
        buttonName: __('Start trial'),
        img: 'servicetitan-1',
    },
    {
        icon: 'users',
        title: __('Send new referrals straight into ServiceTitan'),
        description: __(
            'Configure your integration to send all new referrals straight into the ServiceTitan workflows you already use. You can then setup rules to auto-qualify the leads that convert, using various ServiceTitan properties like: lead status, lifecycle stage, deal stages, and custom properties.'
        ),
        buttonName: __('Start trial'),
        img: 'servicetitan-2',
    },
];

export const SERVICE_TITAN_LINKS = {
    embedVideoLink: '',
    videoLink: '',
    appLink: '',
};

export const STRIPE_BLOG = [
    {
        icon: 'link',
        title: __('Generate links for your Stripe contacts '),
        description: __(
            'Use the sync feature to generate referral links for all or some of your contacts in Stripe The sync process will automatically enrol your contacts into your referral program, and update their records in Stripe to show their unique links and tracking stats.'
        ),
        buttonName: __('Start trial'),
        img: 'stripe-1',
    },
    {
        icon: 'users',
        title: __('Send new referrals straight into Stripe'),
        description: __(
            'Configure your integration to send all new referrals straight into the Stripe workflows you already use. You can then setup rules to auto-qualify the leads that convert, using various Stripe properties like: lead status, lifecycle stage, deal stages, and custom properties.'
        ),
        buttonName: __('Start trial'),
        img: 'stripe-2',
    },
];

export const STRIPE_LINKS = {
    embedVideoLink: 'https://www.youtube.com/embed/yZ9Bd2tjxP8?si=pI-yxwPGEFkCrOsb',
    videoLink: 'https://www.youtube.com/watch?v=yZ9Bd2tjxP8',
    appLink: 'https://marketplace.stripe.com/apps/referral-factory-bv',
};

export const ZAPIER_BLOG = [
    {
        icon: 'link',
        title: __('Generate links for your Zapier contacts '),
        description: __(
            'Use the sync feature to generate referral links for all or some of your contacts in Zapier The sync process will automatically enrol your contacts into your referral program, and update their records in Zapier to show their unique links and tracking stats.'
        ),
        buttonName: __('Start trial'),
        img: 'zapier-1',
    },
    {
        icon: 'users',
        title: __('Send new referrals straight into Zapier'),
        description: __(
            'Configure your integration to send all new referrals straight into the Zapier workflows you already use. You can then setup rules to auto-qualify the leads that convert, using various Zapier properties like: lead status, lifecycle stage, deal stages, and custom properties.'
        ),
        buttonName: __('Start trial'),
        img: 'zapier-2',
    },
];

export const ZAPIER_LINKS = {
    embedVideoLink: '',
    videoLink: '',
    appLink: 'https://zapier.com/apps/referral-factory/integrations',
};

export const ZOHO_BLOG = [
    {
        icon: 'link',
        title: __('Generate links for your Zoho contacts'),
        description: __(
            'Use the sync feature to generate referral links for all or some of your contacts in Zoho The sync process will automatically enrol your contacts into your referral program, and update their records in Zoho to show their unique links and tracking stats.'
        ),
        buttonName: __('Start trial'),
        img: 'zoho-1',
    },
    {
        icon: 'users',
        title: __('Send new referrals straight into Zoho'),
        description: __(
            'Configure your integration to send all new referrals straight into the Zoho workflows you already use. You can then setup rules to auto-qualify the leads that convert, using various Zoho properties like: lead status, lifecycle stage, deal stages, and custom properties.'
        ),
        buttonName: __('Start trial'),
        img: 'zoho-2',
    },
];

export const ZOHO_LINKS = {
    embedVideoLink: 'https://www.youtube.com/embed/ygZ5OFoCKcQ?si=oGpqXVRaYMteu0z2',
    videoLink: 'https://www.youtube.com/watch?v=ygZ5OFoCKcQ',
    appLink: 'https://marketplace.zoho.com/app/crm/referral-factory-for-zoho-crm',
};

export const MAKE_BLOG = [
    {
        icon: 'link',
        title: __('Generate links for your Make.com contacts'),
        description: __(
            'Use the sync feature to generate referral links for all or some of your contacts in Make.com The sync process will automatically enrol your contacts into your referral program, and update their records in Make.com to show their unique links and tracking stats.'
        ),
        buttonName: __('Start trial'),
        img: 'make-1',
    },
    {
        icon: 'users',
        title: __('Send new referrals straight into Make.com'),
        description: __(
            'Configure your integration to send all new referrals straight into the Make.com workflows you already use. You can then setup rules to auto-qualify the leads that convert, using various Make.com properties like: lead status, lifecycle stage, deal stages, and custom properties.'
        ),
        buttonName: __('Start trial'),
        img: 'make-2',
    },
];

export const MAKE_LINKS = {
    embedVideoLink: 'https://www.youtube.com/embed/ygZ5OFoCKcQ?si=oGpqXVRaYMteu0z2',
    videoLink: 'https://www.youtube.com/watch?v=ygZ5OFoCKcQ',
    appLink: 'https://marketplace.zoho.com/app/crm/referral-factory-for-zoho-crm',
};
